import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DesignComponent } from './pages/design/design.component';
import { ModelComponent } from './pages/design/model/model.component';
import { LayoutComponent } from './pages/design/layout/layout.component';
import { OvenComponent } from './pages/design/oven/oven.component';
import { FurnitureComponent } from './pages/design/furniture/furniture.component';
import { ModalsComponent } from './modals/modals.component';
import { HomeComponent } from './pages/home/home.component';
import { DatasService } from './services/datas.service';
import { RecapComponent } from './pages/design/recap/recap.component';
import { CurrentService } from './services/current.service';
import { StyleComponent } from './pages/design/style/style.component';
import { BtnComponent } from './ui/btn/btn.component';
import { ModalService } from './services/modal.service';
import { BymeService } from './services/byme.service';
import { ConfigurationComponent } from './pages/configuration/configuration.component';
import { ProjectsComponent } from './modals/projects/projects.component';
import { PriceInfosComponent } from './modals/price-infos/price-infos.component';
import { ProjectComponent } from './pages/project/project.component';
import { ProductsListComponent } from './modals/products-list/products-list.component';

import { RecaptchaModule } from 'ng-recaptcha';

import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { Nl2BrPipe } from './services/pipes/nl2br.pipe';
import { environment } from '../environments/environment';
import { PrintMediasComponent } from './modals/print-medias/print-medias.component';
import { ImageZoomComponent } from './modals/image-zoom/image-zoom.component';
import { SafeHtmlPipe, SafeStylePipe } from './services/pipes/safe.pipe';
import { LoaderComponent } from './ui/loader/loader.component';
import { EditableTextComponent } from './ui/editable-text/editable-text.component';
import { ProjectDuplicateComponent } from './modals/project-duplicate/project-duplicate.component';
import { ProjectDeleteComponent } from './modals/project-delete/project-delete.component';
import { MagentoService } from './services/magento.service';
import { ErrorComponent } from './pages/error/error.component';
import { PromptComponent } from './modals/prompt/prompt.component';
import { SearchCustomerComponent } from './modals/search-customer/search-customer.component';
import { BannerComponent } from './pages/banner/banner.component';
import { AssistanceComponent } from './modals/assistance/assistance.component';
import { QRCodeModule } from 'angularx-qrcode';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { StoreStockComponent } from './modals/store-stock/store-stock.component';
import { GTM } from './services/gtm.service';
import { OrderMessageComponent } from './modals/order-message/order-message.component';
import { ShareComponent } from './modals/share/share.component';
import { EventDataTransferService } from './services/event-data-transfer.service';

registerLocaleData(localeFr);

@NgModule({
  declarations: [
    AppComponent,
    DesignComponent,
    ModelComponent,
    LayoutComponent,
    OvenComponent,
    FurnitureComponent,
    ModalsComponent,
    HomeComponent,
    RecapComponent,
    StyleComponent,
    BtnComponent,
    ConfigurationComponent,
    ProjectsComponent,
    PriceInfosComponent,
    ProjectComponent,
    ProductsListComponent,
    ProjectDuplicateComponent,
    ProjectDeleteComponent,
    Nl2BrPipe,
    SafeHtmlPipe,
    SafeStylePipe,
    PrintMediasComponent,
    ImageZoomComponent,
    LoaderComponent,
    EditableTextComponent,
    ErrorComponent,
    PromptComponent,
    SearchCustomerComponent,
    BannerComponent,
    AssistanceComponent,
    StoreStockComponent,
    OrderMessageComponent,
    ShareComponent
  ],
  imports: [
    BrowserModule,
    RecaptchaModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient]
      }
    }),
    QRCodeModule,
    FontAwesomeModule
  ],
  providers: [
    GTM,
    EventDataTransferService,
    DatasService,
    CurrentService,
    ModalService,
    BymeService,
    MagentoService,
    {
      provide: 'googleTagManagerId',
      useValue: environment.gtm.id
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/locales/', '.json?v=' + environment.version);
}